import React from 'react';
import { Avatar, AvatarGroup, Grid, Typography } from '@mui/material';
import { useResourceShares } from 'hooks/share/useResourceShare';

import { SparkButton } from 'sharedComponents/UI';
import { ResourceShare } from 'types/Share/ResourceShares';

type CollaboratorSectionProps = {
  onManageClick: () => void;
  resourceID: string;
  resourceTypeID: string;
  accessLevelShares: ResourceShare[];
};

function CollaboratorSection({
  onManageClick,
  resourceID,
  resourceTypeID,
  accessLevelShares,
}: CollaboratorSectionProps) {
  const { getResourceShareUser } = useResourceShares(
    resourceID,
    resourceTypeID
  );

  const getFirstLetter = (userID: string | null) => {
    if (!userID) {
      return;
    }

    const user = getResourceShareUser(userID);

    if (!user) {
      return;
    }

    return user.attributes.name.split('')[0];
  };

  const getProfileImageURL = (userID: string | null) => {
    if (!userID) {
      return;
    }

    const user = getResourceShareUser(userID);

    if (!user) {
      return;
    }

    return user.attributes.profilePictureURL;
  };

  const sortedAccessLevelShares = accessLevelShares?.sort((a, b) => {
    const AUserID = a.attributes.userID;
    const BUserID = b.attributes.userID;

    if (getProfileImageURL(AUserID) && !getProfileImageURL(BUserID)) {
      return -1;
    }
    if (!getProfileImageURL(AUserID) && getProfileImageURL(BUserID)) {
      return 1;
    }

    if (getFirstLetter(AUserID) && !getFirstLetter(BUserID)) return -1;
    if (!getFirstLetter(AUserID) && getFirstLetter(BUserID)) return 1;

    return 0;
  });

  const getName = (userID: string | null, email?: string | null) => {
    if (!userID) {
      return email;
    }

    const user = getResourceShareUser(userID);

    if (!user) {
      return email;
    }

    return user.attributes.name;
  };

  const isDisabled = !accessLevelShares?.length;

  return (
    <Grid container padding={2} gap={1}>
      <Grid
        container
        item
        xs={12}
        justifyContent='space-between'
        alignItems='center'
        flexWrap='nowrap'
      >
        <Typography
          sx={{
            color: 'black',
            fontFamily: 'Mont-SemiBold',
            paddingLeft: 2,
          }}
        >
          Collaborators
        </Typography>
        <SparkButton disabled={isDisabled} onClick={onManageClick}>
          Manage
        </SparkButton>
      </Grid>
      <Grid item>
        <AvatarGroup
          total={accessLevelShares?.length}
          sx={{
            '& .MuiAvatar-root': {
              bgcolor: (theme) => theme.palette.primary.light,
              color: (theme) => theme.palette.primary.main,
            },
          }}
        >
          {sortedAccessLevelShares?.map((shares) => (
            <Avatar
              key={shares.id}
              alt={shares.attributes.createdAt}
              src={getProfileImageURL(shares.attributes.userID) || ''}
            >
              {/* {getAvatarContent(shares.attributes.userID)} */}
              <Typography>
                {getName(shares.attributes.userID, shares.attributes.email)
                  ?.slice(0, 2)
                  .toUpperCase()}
              </Typography>
            </Avatar>
          ))}
        </AvatarGroup>
      </Grid>
    </Grid>
  );
}

export default CollaboratorSection;
